import React from "react";
import { Outlet } from "react-router-dom";
import { ApiProvider } from "../../contexts/ApiContext";
import { useAuth } from "../../contexts/AuthContext";
import Sidebar from "./Sidebar";
import "../../styles/dashboard.css";

// Shell for the /app zone: sidebar + the active section (nested route).
function DashboardLayout() {
  const { isGuest } = useAuth();
  return (
    <ApiProvider isGuest={isGuest}>
      <div className="dashboard">
        <Sidebar />
        <main className="dashboard-main">
          <Outlet />
        </main>
      </div>
    </ApiProvider>
  );
}

export default DashboardLayout;
